import { motion } from "framer-motion";
import React from "react";
import { Container, Row } from "react-bootstrap";
import { pageTransition, pageVariants } from "../../hooks/pagetransition";
import a1 from '../../images/1.png';
import a324 from '../../images/324.png';
import artb from '../../images/Artboard 1.1.jpg';
import cb15 from '../../images/cb15.png';
import CQ1 from '../../images/CQ1.png';
import cs23 from '../../images/CS23.jpg';
import "./Resource.css";

const Resource = () => {
  return (
    <motion.div
    className="pb-3"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Container>
        <Row xs={1} md={2} lg={3}>
          <div className="resourceCard">
            <img
              src={cb15}
              alt=""
            />
            <h1>
              CLIMATE BYTES
            </h1>
          </div>
          <div className="resourceCard">
            <img
              src={CQ1}
              alt=""
            />
            <h1>
              CLIMATE QUOTES
            </h1>
          </div>
          <div className="resourceCard">
            <img
              src={artb}
              alt=""
            />
            <h1>
              CLIMATE SIGHTS
            </h1>
          </div>
          <div className="resourceCard">
            <img
              src={a1}
              alt=""
            />
            <h1>
              INFO GRAPHICS
            </h1>
          </div>
          <div className="resourceCard">
            <img
              src={a324}
              alt=""
            />
            <h1>
              GREEN SHOUT
            </h1>
          </div>
          <div className="resourceCard">
            <img
              src={cs23}
              alt=""
            />
            <h1>
              CLIMATE STREAM
            </h1>
          </div>
        </Row>
      </Container>
    </motion.div>
  );
};

export default Resource;
